import { gql } from "apollo-boost";

const orgDict = gql`
  query ($filter: OrgFilter) {
    orgs(filter: $filter) {
      total
      items {
        id
        name
        canFund
        isSchool
        grades
      }
    }
  }
`;

export const gradeList = gql`
  {
    gradeList
  }
`;

const orgs = gql`
  query ($filter: OrgFilter) {
    orgs(filter: $filter) {
      total
      items {
        id
        name
        grades
        activeUserCount
        communityId
        community {
          id
          name
        }
        divisionId
        division {
          id
          name
        }
        state
        city
        street
        zipCode
        description
        createDate
        isSchool
        canFund
      }
    }
  }
`;

const getEditOrg = gql`
  query org($id: String!) {
    org(id: $id) {
      id
      name
      communityId
      divisionId
      division {
        id
        name
      }
      logo
      state
      city
      street
      zipCode
      description
      createDate
      isSchool
      canFund
      grades
    }
  }
`;

export const GetOrg = gql`
  query org($id: String!) {
    org(id: $id) {
      id
      name
      logo
      divisionId
      division {
        id
        name
      }
      state
      city
      street
      zipCode
      description
      createDate

      community {
        id
        name
        status
      }

      canFund
      isSchool

      children {
        id
        name
        description
        createDate

        contactName
        contactPhone
        contactEmail
        bankRouting
        bankAccount
        stripAccount
        badge
        admins {
          id
          name
        }
        fundraisers {
          id
          name
        }
      }

      admins {
        teacher {
          id
          name
          email
        }
      }
      grades
      fundraisers {
        id
        name
      }
    }
  }
`;

export const FindStudents = gql`
  query students($orgId: String!) {
    students(orgId: $orgId) {
      childId
      firstName
      lastName
      name
      parents {
        id
        name
      }
      grade
    }
  }
`;

export const orgMembers = gql`
  query orgMembers($id: String!) {
    orgMembers(id: $id) {
      id
      name
      title
      firstName
      lastName
      email
      childGrades
      lastActivity
      appRate
      userRate
      level
      state
      profile {
        idStatus
        dlStatus
      }

      poolInfo {
        lastModifiedDate
        enabled
        status
      }
    }
  }
`;

export const FindApplyingStudents = gql`
  query applyingStudents($orgId: String!) {
    applyingStudents(orgId: $orgId) {
      childId
      childName
      userName
      orgId
      grade
      createDate
      updateGrade
      updateSchool {
        id
        name
      }
    }
  }
`;

export const ImportedStudents = gql`
  query importedStudents($orgId: String!) {
    importedStudents(orgId: $orgId) {
      id
      firstName
      lastName
      grade
      parentFirstName
      parentLastName
      email
      createDate
      type
      code
      state
      childId
      parentId
    }
  }
`;

const saveOrg = gql`
  mutation saveOrg($input: FmOrgInput!) {
    saveOrg(input: $input)
  }
`;

const confirmOrg = gql`
  mutation confirmOrg($input: FmOrgInput!) {
    confirmOrg(input: $input)
  }
`;

export const SaveFrOrganizer = gql`
  mutation saveFrOrganizer($input: FrOrganizerInput!) {
    saveFrOrganizer(input: $input)
  }
`;

export const AddOrgAdmin = gql`
  mutation addOrgAdmin($id: String!, $email: String!) {
    addOrgAdmin(id: $id, email: $email)
  }
`;

const addOrgMember = gql`
  mutation addOrgMember($orgId: String!, $userId: String!) {
    addOrgMember(orgId: $orgId, userId: $userId)
  }
`;

export const uploadOrgData = gql`
  mutation uploadOrgData($input: [OrgImportedInput!]!) {
    uploadOrgData(input: $input) {
      orgId
      childFirstName
      childLastName
      childGrade
      childEmail
      parentFirstName
      parentLastName
      parentEmail
      parentMobile
      childId
      parentId
      errors
    }
  }
`;

export const importOrgData = gql`
  mutation importOrgData($input: [OrgImportedInput!]!) {
    importOrgData(input: $input)
  }
`;

export const OrgGql = {
  org: GetOrg,
  getEditOrg,
  saveOrg,
  confirmOrg,
  orgs,
  orgDict,
  orgMembers,
  addOrgMember,
  gradeList,
  uploadOrgData,
  importOrgData,
};
